import { Component, effect, inject, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { NURSING_ORDERS_FIELD } from 'src/app/global';
import { HtmlDialogComponent } from 'src/app/shared/html-dialog/html-dialog.component';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';
import { Note } from 'src/app/calvin-emr-shared/models/note.model';
import { toTitleCase } from 'src/app/shared/utils/string.util';
import { PatientDashboardTabComponent } from '../../dashboard-tab/dashboard-tab.component';
import { NoteDialogComponent } from '../note-dialog/note-dialog.component';

import { ButtonDirective } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-nursing-orders-tab',
  templateUrl: './nursing-orders-tab.component.html',
  styleUrls: ['./nursing-orders-tab.component.scss'],
  providers: [DialogService],
  standalone: true,
  imports: [
    ButtonDirective,
    TableModule,
    PrimeTemplate,
    TooltipModule
],
})
export class NursingOrdersTabComponent extends PatientDashboardTabComponent implements OnInit {

  allNursingOrders: Note[] = [];
  // nonOrderSetNursingOrders: Note[] = [];

  public dialogService = inject(DialogService);

  constructor() {
    super();
    effect(() => {
      this.allNursingOrders = this.patientStore.patient().nursingOrders;
      // this.nonOrderSetNursingOrders = patient.nursingOrders.filter(no => !no.isInOrderSet);
    });
  }

  ngOnInit(): void {
    this.stopLoading();
  }

  viewOrder(order: Note) {
    const dialogRef = this.dialogService.open(HtmlDialogComponent, {
      header: order.title,
      data: order,
      width: '50%',
    });
  }

  deleteOrder(order: Note) {
    this.allNursingOrders = this.allNursingOrders.filter((n) => {
      return n.id !== order.id;
    });
    this.updatePatientField(NURSING_ORDERS_FIELD, this.allNursingOrders);
  }

  openOrderDialog(type: 'create' | 'edit', order?: Note) {
    const header = `${toTitleCase(type)} Order`;
    let data = order ?
      {
        type: type,
        note: order,
        forOrderSet: false,
      } :
      {
        type: type,
        forOrderSet: false,
      };

    const dialogRef = this.dialogService.open(NoteDialogComponent, {
      header: header,
      width: '90%',
      data: data,
    });

    dialogRef?.onClose.subscribe((order: Note) => {
      if (order) {
        if (type === 'create') {
          this.allNursingOrders.push(order);
        } else if (type === 'edit') {
          const indexToRemove = this.allNursingOrders.findIndex((n) => n.id == order.id);
          this.allNursingOrders.splice(indexToRemove, 1, order);
        }

        this.updatePatientField(NURSING_ORDERS_FIELD, this.allNursingOrders);
      }
    });
  }
}
